module.exports = {
      id: "microphone-usage",
      viewBox: "0 0 18.224 28.474",
      url: "img/" + "sprite.svg#microphone-usage",
      toString: function () {
        return this.url;
      }
    }